<template>
  <MainLayout>
    <div class="discovery-main">
      <LayoutSection size="o5v90">
        <el-row>
          <el-col>
            <div class="text-left pl-10 pt-50 title">
              <h2>{{ $t("discovery.title") }}</h2>
            </div>
          </el-col>
        </el-row>
        <el-row class="alt-section">
          <el-col :xs="24" :sm="24" :md="{ span: 13, offset: 2 }" class="img">
            <div class="text-center">
              <img :src="image.tel" class="telphone-image" />
            </div>
          </el-col>
          <el-col class="description" :xs="24" :sm="24" :md="10">
            <h3 class="text-left mb-20">
              {{ $t("discovery.section1.heading") }}
            </h3>
            <p>
              {{ $t("discovery.section1.description") }}
            </p>
          </el-col>
        </el-row>
        <el-row class="alt-section">
          <el-col
            class="description"
            :xs="24"
            :sm="24"
            :md="{ span: 9, offset: 3 }"
          >
            <h3 class="text-left mb-20">
              {{ $t("discovery.section2.heading") }}
            </h3>
            <p>
              {{ $t("discovery.section2.description") }}
            </p>
          </el-col>
          <el-col :xs="24" :sm="24" :md="10" class="img">
            <div class="text-center">
              <img :src="image.wine" class="telphone-image" />
            </div>
          </el-col>
        </el-row>
        <el-row class="alt-section">
          <el-col :xs="24" :sm="24" :md="{ span: 13, offset: 2 }" class="img">
            <div class="text-center">
              <img :src="image.prices" class="prices-image" />
            </div>
          </el-col>
          <el-col class="description" :xs="24" :sm="24" :md="12">
            <h3 class="text-left mb-20">
              {{ $t("discovery.section3.heading") }}
            </h3>
            <p v-html="$t('discovery.section3.description')"></p>
          </el-col>
        </el-row>
      </LayoutSection>
      <el-row :gutter="10" class="box mb-50 three-main-section">
        <el-col :xs="24" :sm="24" :md="{ span: 21, offset: 2 }">
          <p class="tag-line text-left mb-15">{{ $t("discovery.package") }}</p>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="{ span: 7, offset: 2 }"
          class="three-main-section-one"
        >
          <div class="bg-accent-light pt-50 pb-50 box-1 pr-10 pl-10">
            <h3 class="pb-15 become-member">
              {{ $t("discovery.box1.title") }}
            </h3>
            <p class="text-center pb-15">
              {{ $t("discovery.box1.description") }}
            </p>
            <p
              class="text-center pb-15"
              v-html="
                priceFormat($t('discovery.box1.plan')) +
                $t('discovery.box1.time')
              "
            ></p>
            <el-button type="primary" class="subscribe">
              {{ $t("discovery.box1.subscribe") }}
            </el-button>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="7">
          <div class="bg-accent-light pt-50 pb-50 box-1 pr-10 pl-10">
            <h3 class="pb-15 become-member">
              {{ $t("discovery.box2.title") }}
            </h3>
            <p class="text-center pb-15">
              {{ $t("discovery.box2.description") }}
            </p>
            <p
              class="text-center pb-15"
              v-html="
                priceFormat($t('discovery.box2.plan')) +
                $t('discovery.box2.time')
              "
            ></p>
            <el-button type="primary" class="subscribe">
              {{ $t("discovery.box1.subscribe") }}
            </el-button>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="7">
          <div class="bg-accent-light pt-50 pb-50 box-1 pr-10 pl-10">
            <h3 class="pb-15 become-member">
              {{ $t("discovery.box3.title") }}
            </h3>
            <p class="text-center pb-15">
              {{ $t("discovery.box3.description") }}
            </p>
            <p
              class="text-center pb-15"
              v-html="
                priceFormat($t('discovery.box3.plan')) +
                $t('discovery.box3.time')
              "
            ></p>
            <el-button type="primary" class="subscribe">
              {{ $t("discovery.box1.subscribe") }}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24" :md="{ span: 21, offset: 2 }">
          <p class="tag-line text-center mb-70">
            {{ $t("discovery.commitment") }}
          </p>
        </el-col>
      </el-row>
    </div>
  </MainLayout>
</template>

<script>
import { formatCurrency, specialFormatCurrency } from "@/utils/common-utils";
import LayoutSection from "@/components/layout/layout-section.vue";
import MainLayout from "@/components/layout/main-layout.vue";
import wine from "@/assets/images/membre/wine.png";
import prices from "@/assets/images/membre/prices.png";
import appointment from "@/assets/images/membre/appointment.png";
import eventsimg from "@/assets/images/membre/event.png";
import tel from "@/assets/images/membre/tel.png";

export default {
  components: {
    MainLayout,
    LayoutSection,
  },
  data() {
    return {
      title: "Subscriptions",
      subscriptions: "",
      image: {
        tel: tel,
        wine: wine,
        appointment: appointment,
        event: eventsimg,
        prices: prices,
      },
    };
  },
  methods: {
    priceFormat(price) {
      if (this.$i18n.locale == "fr-CA" || this.$i18n.locale == "en-US") {
        var formatPrice = specialFormatCurrency(price, this.$i18n.locale);
        if (this.$i18n.locale == "en-US") {
          formatPrice = formatPrice.split(".");
        } else {
          formatPrice = formatPrice.split(",");
        }
        if (formatPrice.length == 1) {
          formatPrice.push("00");
        }
        return `${
          formatPrice[0]
        }<sup style="font-size: 10px; line-height: 0; vertical-align: 5px;"> ${formatPrice[1]
          .toString()
          .padEnd(2, "0")}</sup> $`;
      }
      return formatCurrency(price, this.$i18n.locale);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/variables.scss";
.previousBtn {
  .el-button--text {
    color: #a31c25;
    cursor: pointer;
    font-weight: 500 !important;
  }
  .previousBtn {
    color: $color-primary;
    cursor: pointer;
    padding-bottom: 20px;
  }
  .el-button:hover {
    text-decoration: underline;
  }
}
</style>